import React, { FC } from 'react';

import Grid from '@mui/material/Grid';

interface ObjectBreakdownProps {
  data?: Record<string, any>;
}

const ObjectBreakdown: FC<ObjectBreakdownProps> = (props) => {
  let { data } = props;

  return (
    data && (
      <Grid container>
        {Object.keys(data).map((key) => {
          const value =
            typeof data[key] === 'object' && data[key] !== null
              ? JSON.stringify(data[key], null, 2)
              : String(data[key]);

          // crude heuristic: if value is long, take full width
          const isLong = value.length > 80;

          return (
            <Grid item xs={12} md={isLong ? 12 : 4} key={key} style={{ marginBottom: 12 }}>
              <p style={{ fontWeight: 'bold', fontSize: 14 }}>{key}</p>
              <pre
                style={{
                  fontSize: 12,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {value}
              </pre>
            </Grid>
          );
        })}
      </Grid>
    )
  );
};

export default ObjectBreakdown;
